module.exports = isWidget

function isWidget(w) {
    return w && w.type === "Widget"
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vnode/is-widget.js
// module id = 12
// module chunks = 0